import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { LotSummaryGetCollectionByStageId, LotSummaryGetCollectionByStageIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<LotSummaryGetCollectionByStageIdResponse, LotSummaryGetCollectionByStageIdResponse>) => {
    return response?.data?.lotSummaries
}
const getError = (response?: SWRResponse<LotSummaryGetCollectionByStageIdResponse, LotSummaryGetCollectionByStageIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<LotGetCollectionByStageIdResponse, LotGetCollectionByStageIdResponse>) => ({});

const useLotSummariesByStageId = (stageId: number, configuration?: SWRConfiguration<LotSummaryGetCollectionByStageIdResponse, LotSummaryGetCollectionByStageIdResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new LotSummaryGetCollectionByStageId({
                stageId: stageId
            });
        };
    }, [stageId])

    return useGet(request, { getData, getError }, configuration);
}

export default useLotSummariesByStageId;